import { gql } from '@apollo/client';

export const GET_BANNERS = gql`
  query GetBanners {
    banners {
      id
      imageUrl
      header
      midline
      feature
      discount
      styles {
        header {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
        midline {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
        feature {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
        discount {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
      }
    }
  }
`;

export const CREATE_BANNER = gql`
  mutation CreateBanner($input: CreateBannerInput!) {
    createBanner(input: $input) {
      id
      imageUrl
      header
      midline
      feature
      discount
      styles {
        header {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
        midline {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
        feature {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
        discount {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
      }
    }
  }
`;

export const UPDATE_BANNER = gql`
  mutation UpdateBanner( $input: UpdateBannerInput!) {
    updateBanner( input: $input) {
      id
      imageUrl
      header
      midline
      feature
      discount
      styles {
        header {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
        midline {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
        feature {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
        discount {
          color
          font
          align
          fontSize
          fontWeight
          textShadow
          letterSpacing
          lineHeight
        }
      }
    }
  }
`;

export const DELETE_BANNER = gql`
  mutation DeleteBanner($id: ID!) {
    deleteBanner(id: $id)
  }
`;

export const GET_CMS_PAGES = `
  query {
    listCMSPages {
      id
      title
      content
    }
  }
`;


export const UPDATE_CMS_PAGE = `
  mutation UpdateCMSPage($id: ID!, $title: String!, $content: String!) {
    updateCMSPage(id: $id, input: { title: $title, content: $content }) {
      id
      title
      content
    }
  }
`;

export const CREATE_CMS_PAGE = `
  mutation CreateCMSPage($title: String!, $content: String!) {
    createCMSPage(input: { title: $title, content: $content }) {
      id
      title
      content
    }
  }
`;

export const DELETE_CMS_PAGE = `
  mutation DeleteCMSPage($id: ID!) {
    deleteCMSPage(id: $id)
  }
`;
